import { Examples } from '@/types';

export const ExampleErrorNotificationRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
      {
        ...Examples.ExampleErrorNotification,
        components: {
          default: () => import(/* webpackChunkName: "ExampleErrorNotification" */
            '@/views/examples/ExampleErrorNotification.vue')
        }
      }
    ]
    : [];